import { Content } from "../../types/content.interface";

export const aboutMeData: Content[] = [
  {
    isDisplay: true,
    details: [
      {
        linkUrl: "https://blog.dongjun.me",
        linkText: "blog",
        enText: "I'm a S/W developer who wants to draw dreams with code.",
        krText:
          "저는 코드로 꿈을 그리는 사람이 되고 싶은 소프트웨어 개발자입니다.",
        isDisplay: true,
      },
      {
        linkUrl: "https://github.com/americano212",
        linkText: "github",
        enText:
          "Now I'm interested backend, which designs infrastructure and creates APIs.",
        krText: "현재는 인프라를 설계하고, API를 만드는 백엔드에 관심있습니다.",
        isDisplay: true,
      },
    ],
  },
];
